import { render, staticRenderFns } from "./sendConfirmDialog.vue?vue&type=template&id=89437426&scoped=true"
import script from "./sendConfirmDialog.vue?vue&type=script&lang=js"
export * from "./sendConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./sendConfirmDialog.vue?vue&type=style&index=0&id=89437426&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89437426",
  null
  
)

export default component.exports